import { Flex, Spinner } from "@chakra-ui/react";

const RelativeLoader = () => (
  <Flex justify="center" align="center" w="100%" h="100%">
    <Flex justify="center" position="relative" zIndex={2}>
      <Spinner color="blue.400" w="30px" h="30px" />
    </Flex>
  </Flex>
);

export default RelativeLoader;
